import _ from 'underscore';
import System from "../../../helper/system";
import store from 'src/storeWire';

class ResponseMaker {
    data = [];
    data_to_send = {};

    constructor(data) {
        this.data = data;
        this.data_to_send = this.defaultValue();
    }

    defaultValue = () => {
        return {
            totalMatches: 0,
            isExternalBom: false,
            bomColumnMapping: {},
            downloadColumnList: {},
            UnMatch: {
                count: 0,
                records: {},
                matchType: 'UnMatch'
            },
            Exact: {
                count: 0,
                deleted: 0,
                records: {},
                matchType: 'Exact'
            },
            Multiple: {
                count: 0,
                deleted: 0,
                records: {},
                matchType: 'Multiple'
            },
            NoMatch: {
                count: 0,
                deleted: 0,
                records: {},
                matchType: 'NoMatch'
            }
        };
    }
    process = async (axiosParams = {}) => {
        let force_all_skip_redux_check_detected = false;
        if (axiosParams.force_all_skip_redux_check !== undefined) {
            force_all_skip_redux_check_detected = axiosParams.force_all_skip_redux_check
        }
        if (this.data.bomDetailsMatchType !== undefined && _.isArray(this.data.bomDetailsMatchType)) {
            this.data.bomDetailsMatchType.map((v) => {
                this.data_to_send[v.matchType] = v
            })
        } else {
            this.data_to_send.bomDetailsMatchType = {};
        }
        if (this.data.downloadColumnList !== undefined && _.isArray(this.data.downloadColumnList)) {
            this.data.downloadColumnList.map((v) => {
                this.data_to_send.downloadColumnList[System.anythingToCamel(v)] = {
                    fileColumnName: v,
                    columnName: System.anythingToCamel(v)
                };
            })
        } else {
            this.data_to_send.downloadColumnList = {};
        }


        if (this.data.bomMatches !== undefined) {
            let s = store.getState();
            let records = {}
            if (axiosParams.skip === 0) {
                records = this.data_to_send;
            } else {
                records = JSON.parse(JSON.stringify(s.entities.model_BOM.bomDetailByBomIDWithType));
                if (Object.entries(records).length < 1) {
                    records = this.data_to_send;
                }
                records = { ...records };
            }
            if (_.isArray(this.data.bomMatches)) {

                let bomDetailIds = []
                this.data.bomMatches.map(async (v, i) => {
                    v.ERPPartNumberModified = false;
                    if(!v.erpPartNumber)
                    {
                        v.ERPPartNumberModified = true;
                    }
                    v.partNumberRaw = v.partNumber;
                    if (!v.erpPartNumber) {
                        v.erpPartNumber = v.itemNumber;
                    }
                    if (v.erpPartNumber) {
                        v.partNumber = v.erpPartNumber;
                    } else {
                        v.partNumber = null;
                    }
                    v.ERPPartNumber = v.erpPartNumber;
                    // v.product_contract_id = v.bomDetailId;
                    if (!v.manufacturerPartNumber) {
                        v.manufacturerPartNumber = v.partNumberRaw
                    }
                    if (records[v.matchType] === undefined) {
                        records[v.matchType] = this.defaultValue()[v.matchType];
                    }
                    if (records[v.matchType].records === undefined) {
                        records[v.matchType].records = {};
                    }
                    if (records[v.matchType].records[v.bomDetailId] === undefined) {
                        i = Object.entries(records[v.matchType].records).length + 1
                        records[v.matchType].records[v.bomDetailId] = {};
                    }
                    if (this.data_to_send[v.matchType] !== undefined && this.data_to_send[v.matchType].count !== undefined) {
                        records[v.matchType].count = this.data_to_send[v.matchType].count;
                    }
                    if (this.data_to_send[v.matchType] !== undefined && this.data_to_send[v.matchType].deleted !== undefined) {
                        records[v.matchType].deleted = this.data_to_send[v.matchType].deleted;
                    }
                    records[v.matchType].records[v.bomDetailId] = { ...v, index: i };

                    if (v.matchType === 'Exact') {
                        bomDetailIds.push(v)
                    }
                    // records[v.matchType]['recordList'] = bomDetailIds
                });
            }

            // let originalObject = {
            //     [this.data.bomMatches[0].bomDetailId] : this.data.bomMatches[0],
            //     [this.data.bomMatches[1].bomDetailId] : this.data.bomMatches[1]
            // }

            records['Exact'].count = this.data_to_send['Exact'].count;
            records['Multiple'].count = this.data_to_send['Multiple'].count;
            records['NoMatch'].count = this.data_to_send['NoMatch'].count;

            records['Exact'].deleted = this.data_to_send['Exact'].deleted;
            records['Multiple'].deleted = this.data_to_send['Multiple'].deleted;
            records['NoMatch'].deleted = this.data_to_send['NoMatch'].deleted;
            this.data_to_send = records;
        }

        if (this.data.totalMatches !== undefined) {
            this.data_to_send.totalMatches = this.data.totalMatches;
        } else {
            this.data_to_send.totalMatches = 0;
        }

        if (this.data.isExternalBom) {
            this.data_to_send.isExternalBom = this.data.isExternalBom;
        }


        if (this.data.bomColumnMapping !== undefined) {
            let bomColumnMapping = {};
            if (_.isArray(this.data.bomColumnMapping)) {
                this.data.bomColumnMapping.map((v) => {
                    bomColumnMapping[v.columnName] = v;
                })
            }
            this.data_to_send.bomColumnMapping = bomColumnMapping;
        }
        return this;
    };

    run = () => {
        return this;
    };

    get = () => {
        return {
            data: this.data_to_send
        };
    };
}

export default ResponseMaker;